import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import LoadScript from 'vue-plugin-load-script';
import VuePlyr from 'vue-plyr'
import browserDetect from "vue-browser-detect-plugin";
import fullscreen from 'vue-fullscreen'
import VueAppInsights from 'vue-application-insights'
import VueThreeSixty from 'vue-360'
import 'vue-360/dist/css/style.css'

Vue.config.productionTip = false

Vue.use(browserDetect);
Vue.use(LoadScript);
Vue.use(VueThreeSixty);
Vue.use(fullscreen);
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: true, iosNative: true }
  },
  emit: ['ended']
})

Vue.use(VueAppInsights, {
  id: 'e8fb527e-b0fa-4f7e-b874-cd3bec7b4ccb'
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

